import React, { useState } from 'react';
import { LeadForm } from '../LeadForm';

import styles from './SidebarLeadForm.module.scss';
import { GTM_ACTION, BUTTON_TEXT } from '../../../lib/constant';

interface SidebarLeadForm {
  category?: string;
  title?: string;
}

const SidebarLeadForm = (props: SidebarLeadForm) => {
  const { category, title } = props;
  const [submittedLead, setSubmittedLead] = useState(false);

  const showLeadContent = () => {
    return (
      <>
        <div className={styles.sidebarLeadform__title}>
          {title ? title : 'Bandingkan Pilihan Asuransi Terbaik dan Termurah di Lifepal!'}
        </div>
        <div className={styles.sidebarLeadform__subtitle}>
          <div>
            Dapatkan <span className="label-discount">DISKON 25% </span>
          </div>
          <div> Daftar sekarang untuk penawaran terbatas</div>
        </div>
        <LeadForm
          category={category ? category : 'media'}
          background="dark"
          gtmAction={GTM_ACTION.SIDEBAR_LEADFORM}
          submittedMediaLeadform={() => setSubmittedLead(true)}
          buttonText={BUTTON_TEXT.sidebar}
        />
      </>
    );
  };

  const showLeadThankYou = () => {
    return (
      <div className={styles.sidebarLeadform__thank}>
        <img
          src="/media/static/images/mediaLeadSubmit.svg"
          alt="Media lead submit"
          width={120}
          height={120}
        />
        <div className={styles.sidebarLeadform__thank__title}>Terima kasih Telah Mengisi Form</div>
        <div className={styles.sidebarLeadform__thank__subtitle}>
          Anda akan dihubungi pihak Lifepal untuk informasi lebih lanjut
        </div>
      </div>
    );
  };

  return (
    <div className={styles.sidebarLeadform}>
      {submittedLead ? showLeadThankYou() : showLeadContent()}
    </div>
  );
};
export default SidebarLeadForm;
